




























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CurrentPoint extends Vue {
  @Prop()
  point!: number;
  @Prop({ required: false })
  configStyle!: string;
  @Prop({ required: false })
  backgroundColor!: string;
  @Prop({ required: false })
  fontColor!: string;
}
